import { get } from 'lodash';
import { combineReducers } from 'redux';

import { DEFAULT_ACTION } from '../../constants';
import * as actionTypes from './actionTypes';

const initialState = {
    isLoading: false,
    districts: []
};

export const isLoading = (state = initialState.isLoading, action = DEFAULT_ACTION) => {
    switch (action.type) {
        case actionTypes.GET_DISTRICTS_SUCCESS:
        case actionTypes.GET_DISTRICTS_FAIL:
            return false;
        case actionTypes.GET_DISTRICTS_START:
            return true;
        case actionTypes.RESET:
            return initialState.isLoading;
        default:
            return state;
    }
};

export const districts = (state = initialState.districts, action = DEFAULT_ACTION) => {
    switch (action.type) {
        case actionTypes.GET_DISTRICTS_SUCCESS:
            return action.payload;
        case actionTypes.RESET:
            return initialState.districts;
        default:
            return state;
    }
};

export const getIsLoading = state => get(state, 'isLoading', initialState.isLoading);

export const getDistricts = state => get(state, 'districts', initialState.districts);

const reducer = combineReducers({
    isLoading,
    districts
});

export default reducer;
